/**
 * Adds an observer to timeline nodes and highlights them
 * when they scroll past the middle of the page
 * @param {HTMLNode} rootElement The component dom node
 */
export default function(rootElement) {
  const items = rootElement.querySelectorAll('[data-annotation-title]');
  if (!items.length) {
    return;
  }

  function hideAll() {
    items.forEach(item => {
      item.setAttribute('aria-hidden', true);
      item.parentNode.removeAttribute('data-active');
    });
  }

  function show(parent) {
    hideAll();

    const styles = window.getComputedStyle(this, ':after');
    const width = parseInt(styles.getPropertyValue('width'), 10);
    const height = parseInt(styles.getPropertyValue('height'), 10);

    const bounds = this.getBoundingClientRect();

    const x = bounds.left;
    const y = bounds.top;
    const xoffset = (window.innerWidth - (x + width / 2));

    this.removeAttribute('data-offset-x');
    this.removeAttribute('data-offset-y');

    if (xoffset < 0) {
      this.setAttribute('data-offset-x', 'right');
    }

    if (x < width / 2) {
      this.setAttribute('data-offset-x', 'left');
    }

    if (y < height) {
      this.setAttribute('data-offset-y', 'bottom');
    }

    this.setAttribute('aria-hidden', false);
    parent.setAttribute('data-active', true);
  }

  items.forEach(item => {
    item.parentNode.onclick = show.bind(item, item.parentNode);
    item.onblur = hideAll;
  });

  document.addEventListener('click', hideAll, true);
}
